import { dashboardMarketingBannerApi, marketingBannerCRUDApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getBanners = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dashboardMarketingBannerApi + `${query || ""}`, config);

    return response;
};

export const postBanner = async (data) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(dashboardMarketingBannerApi, data, config);
    return response;
};

export const patchBanner = async ({ data }) => {
    const config = {
        headers: {
            // "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(dashboardMarketingBannerApi, data, config);
    return response;
};

export const deleteBanner = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.delete(marketingBannerCRUDApi + id + "/", config);

    return response;
};
